module.exports = __webpack_public_path__ + "static/media/info-palen.a4db4fff.png";